import { useQuery } from '@apollo/client';
import { Box, Divider, Flex, Stack, useColorModeValue as mode } from '@chakra-ui/react';
import DashboardCard from '@components/atoms/DashboardCard';
import Button from '@components/interactive/Button';
import Body1 from '@components/typography/Body1';
import Header from '@components/typography/Header';
import { Routes } from '@constants/routes';
import { useAuthenticatedContextProvider } from '@contexts/AuthenticatedContextProvider';
import { GET_ALL_QUOTE_SETS } from '@gql/GetAllQuoteSets';
import medicalPlanIcon from '@public/flaticons/medical-plan.png';
import Image from 'next/image';

const QuotesCard = () => {
  // Resources
  const { authenticatedUser: user } = useAuthenticatedContextProvider();

  // Queries
  const { data: allQuoteSets, loading } = useQuery(GET_ALL_QUOTE_SETS, {
    fetchPolicy: 'no-cache',
    variables: {
      userId: user.id,
    },
  });

  const quoteFromLast3Months = allQuoteSets?.getAllQuoteSets?.find(
    (quoteSet) => new Date(quoteSet.created_at) > new Date(Date.now() - 3 * 30 * 24 * 60 * 60 * 1000)
  );

  // If loading or no quotes from last 3 months, don't show card
  if (loading || !quoteFromLast3Months) {
    return null;
  }

  return (
    <DashboardCard id="quotes_summary_card">
      <Stack direction={['column', 'column', 'row']} alignItems={['stretch', 'stretch', 'normal']}>
        <Divider
          opacity={1}
          borderColor={mode('blue.500', 'blue.200')}
          borderWidth="2px"
          height="inherit"
          borderRadius={5}
          orientation="vertical"
          mr={[0, 0, 4]}
          ml={[0, 0, -5]}
          mb={[6, 6, 0]}
          flexDir="column"
        />
        <Flex w="100%" justifyContent="center" maxW={['100%', '100%', '126px']}>
          <Box
            minW={['80px', '80px', '110px']}
            minH={['80px', '80px', '110px']}
            maxWidth="120px"
            position="relative"
            display="flex"
            alignItems="center"
            mr={[0, 0, '16px !important']}
          >
            <Image src={medicalPlanIcon} alt="Quotes icon" />
          </Box>
        </Flex>
        <Stack pt={[6, 6, 0]}>
          <Header as="h4">My Quotes</Header>
          <Body1 pb={1}>View the plans your agent recently sent you.</Body1>
          <Button
            width={['100%', '100%', 220]}
            href={Routes.quotes}
            isDisabled={allQuoteSets?.getAllQuoteSets?.length <= 0}
          >
            View My Quotes
          </Button>
        </Stack>
      </Stack>
    </DashboardCard>
  );
};

export default QuotesCard;
